import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import { TextField } from 'redux-form-material-ui';
import { Paper } from 'material-ui';
import { FormControl, Button } from '@material-ui/core';
import { API_KEY_ACCOUNTS, LOGIN_API } from '../../constants';
import './styles.css';

const style = {
  layout: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '4rem',
  },
  paper: {
    padding: '16px',
    width: '30%',
  },
  title: {
    fontSize: '1rem',
    margin: '0.5rem auto',
  },
  formgroup: {
    display: 'flex',
    width: '100%',
    flexFlow: 'column',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  signInButton: {
    margin: '16px',
    width: '80%',
  },
  field: {
    margin: '8px 0',
    width: '100%',
  },
};

const propTypes = {
  dispatchUserLogin: PropTypes.func,
};

const SignIn = props => {
  const [formValues, setFormValues] = useState({ email: null, password: null });
  const [error, setError] = useState(false);
  const { dispatchUserLogin } = props;
  const handleFormSubmit = async () => {
    await loginApi(formValues.email, formValues.password);
  };

  const loginApi = async (username, password) => {
    const response = await axios({
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY_ACCOUNTS,
      },
      data: {
        username,
        password,
      },
      url: `${LOGIN_API}`,
      validateStatus(status) {
        return status === 200;
      },
    })
      .then(res => {
        console.log(res);
        dispatchUserLogin({ token: res.data.accessToken, username });
        return 'successful login';
      })
      .catch(e => {
        setError(true);
        console.log(e);
        return 'failed login';
      });
    return response;
  };

  const handleEmailChange = e => {
    setFormValues({
      email: e.target.value,
      password: formValues.password,
    });
  };

  const handlePasswordChange = e => {
    setFormValues({
      email: formValues.email,
      password: e.target.value,
    });
  };

  return (
    <div style={style.layout}>
      <Paper style={style.paper} zDepth={5}>
        <h3 style={style.title}>Sign In</h3>
        <FormControl style={style.formgroup}>
          <TextField
            id="email"
            label="email"
            style={style.field}
            onChange={e => handleEmailChange(e)}
            floatingLabelText="Email"
          />
          <TextField
            id="password"
            label="password"
            style={style.field}
            type="password"
            onChange={e => handlePasswordChange(e)}
            floatingLabelText="Password"
          />
          <Button
            variant="contained"
            onClick={handleFormSubmit}
            style={style.signInButton}
          >
            Submit
          </Button>
          {error && (
            <div>
              <h5> Invalid Login.</h5>
            </div>
          )}
        </FormControl>
      </Paper>
    </div>
  );
};

SignIn.propTypes = propTypes;

// Decorate the form component
export default reduxForm({
  form: 'signIn',
})(SignIn);
